<template>
  <div class="time-sheet" style="margin-top: -32px">
    <SabbaticalFilter
      @updateFilter="updateFilter"
      :tabActive="activedTab"
      :propsMonth="this.paramsMonth"
    />
    <div class="table-list">
      <CCard>
        <CCardBody>
          <div class="card-toolbar">
            <div class="toolbar-title">
              <Tab
                :items="tabItems"
                :countRequest="countRequest"
                :active="activedTab"
                @change="handleChangeTab"
              />
            </div>
            <div class="toolbar-actions">
              <CButton
                v-if="activedTab === 'mine'"
                class="btn-update-attendance"
                @click="openAddSabbaticalRequestModal()"
              >
                <a-icon class="icon_add" type="plus" />
                <span>
                  {{ $t("popup.sabbatical.label_add_sabbtial_request") }}</span
                >
              </CButton>
              <div
                class="time-sheet__button"
                v-if="activedTab === 'need_approve'"
                v-show="listIdsSabbaticalRequestApproved.length > 0"
              >
                <CButton
                  type="button"
                  class="btn btn-accept-employee-overtime ml-0"
                  @click="showModalNote(2)"
                >
                  {{ $t("commons.approve") }}
                </CButton>
                <!-- <CButton
                  class="btn btn-reset ml-2"
                  type="button"
                  @click="showModalNote(3)"
                >
                  {{ $t("commons.cancel_approve") }}
                </CButton> -->
              </div>
            </div>
          </div>
          <div class="card-content">
            <MineTable
              v-if="activedTab === 'mine'"
              :items="sabbaticalLeaveRequests.data"
              @change="handleMineTableChange"
            />
            <ApprovalTable
              ref="approved_ref"
              v-if="activedTab === 'need_approve'"
              :items="sabbaticalLeaveApproval.data"
              @sabbatical-approved="passDataApproved"
              :idsCanCheck="isCanCheck"
              :allSelectedProp="allSelected"
              @change="handleApprovalTableChange"
            />
          </div>
        </CCardBody>
        <CPagination
          v-if="
            sabbaticalLeaveRequests.data &&
            sabbaticalLeaveRequests.data.length > 0 &&
            activedTab === 'mine'
          "
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="changePage"
          size="sm"
          align="center"
        />
        <CPagination
          v-if="
            sabbaticalLeaveApproval.data &&
            sabbaticalLeaveApproval.data.length > 0 &&
            activedTab === 'need_approve'
          "
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="changePageApprover"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
    <CreateSabbaticalRequestModal
    @fetchSabbticalRequestList="fetchSabbticalRequestList"
        ref="createSabbatical"/>
    <template>
      <b-modal ref="modal-note" hide-footer hide-header>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(approveAllSabbaticalRequest)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("commons.note") }}
                  <span class="require" v-if="forms.status === 3">&nbsp;*</span>
                </label>
                <ValidationProvider
                  rules="required|min:1|max:512"
                  v-slot="{ errors }"
                  name="overtime.note"
                  v-if="forms.status === 3"
                >
                  <b-form-textarea
                    v-model="forms.comment"
                    rows="4"
                  ></b-form-textarea>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
                <b-form-textarea
                  v-model="forms.comment"
                  rows="4"
                  v-if="forms.status === 2"
                ></b-form-textarea>
              </CCol>
            </CRow>
            <div class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("button.label_action_accept") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button
                class="mt-3"
                variant="outline-danger"
                @click="hideModalNote"
                >{{ $t("button.label_action_cancel") }}
              </b-button>
            </div>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
    <CusModal
      @handleCancel="hideErrorConfirm"
      @handleOk="hideErrorConfirm"
      :title="$t('popup.commons.label_popup_error')"
      :showCancelBtn="false"
      :isShow="errorModal"
    >
      <div class="text-center">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_error_empty_manager") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import CusModal from "@/components/commons/CusModal.vue";
import moment from "moment";
import CreateSabbaticalRequestModal from "./modal/CreateSabbaticalRequestModal.vue"
import SabbaticalFilter from "./components/SabbaticalFilter";
import Tab from "@/components/commons/Tab/Tab.vue";
import MineTable from "./components/MineTable.vue";
import ApprovalTable from "./components/ApprovalTable.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "SabbaticalRequestList",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_request_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    SabbaticalFilter,
    Tab,
    CusModal,
    MineTable,
    ApprovalTable,
    CreateSabbaticalRequestModal,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      // AlistAdditionalTimeSheetApproval: [],
      tabItems: [
        { key: "mine", label: "Của tôi" },
        { key: "need_approve", label: "Cần duyệt" },
      ],
      countRequest: {
        mine: 0,
        need_approve: 0,
      },
      errorModal:false,
      activedTab: "mine",
      isAddAdditionTimeSheetShow: false,
      paramsMonth: "",
      searchData: {
        itemsPerPage: 10,
        sortColumn: "updated_at",
        sortBy: "DESC",
        status: 0,
        statusTab2: 0,
        employeeInfo: "",
        approvePerson: "",
        approveStatus: 1,
        reason: 0,
        divisionCode: 0,
        positionId: 0,
        startDate: moment().startOf('month').format('DD/MM/YYYY'),
        endDate: moment().endOf('month').format('DD/MM/YYYY'),
        month: moment(),
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
      columnSort: {
        date: "work_date",
        start_time_real: "start_time_real",
        end_time_real: "end_time_real",
        start_time_request: "start_time_request",
        end_time_request: "end_time_request",
      },
      componentKey: 0,
      isOpenAdd: false,
      isCanCheck: [],
      listIdsSabbaticalRequestApproved: [],
      allSelected: false,
      forms: {
        status: 0,
        comment: "",
      },
    };
  },
   created() {
    // window.localStorage.clear();
    // this.searchData.month = moment();
    // if (localStorage.statusListTime) {
    //   this.searchData.status = localStorage.statusListTime;
    // }
    // if (Object.keys(this.$route.query).length !== 0) {
    //   let params = this.$route.query;
    //   params.perPage =
    //     this.listItemsPerPage.includes(parseInt(params.perPage)) &&
    //     !isNaN(params.perPage)
    //       ? params.perPage
    //       : 10;
    //   if (params.month !== undefined) {
    //     this.paramsMonth = moment("01/" + params.month, "DD/MM/YYYY").format(
    //       "DD/MM/YYYY"
    //     );
    //   }
    //   this.searchData = {
    //     employee_info:
    //       params.employeeInfo == undefined
    //         ? this.searchData.employee_info.toLowerCase()
    //         : params.employeeInfo.toLowerCase(),
    //     month:
    //       // params.month == undefined || !this.checkParamIsDate(params.month)
    //       //   ? this.searchData.month
    //       //   : this.reverseParamsDate(params.month),
    //       params.month == undefined
    //         ? this.searchData.month
    //         : moment("01/" + params.month, "DD/MM/YYYY"),
    //     status:
    //       params.status == undefined
    //         ? parseInt(this.searchData.status)
    //         : parseInt(params.status),
    //     itemsPerPage: params.perPage,
    //     sortColumn: params.sortColumn,
    //     sortBy: params.sortBy,
    //     paginate: {
    //       from: params.from,
    //       to: params.to,
    //       totalPage: parseInt(params.totalPage),
    //       path: this.searchData.paginate.path,
    //       currentPage: parseInt(params.currentPage),
    //       totalRecord: parseInt(params.totalRecord),
    //       perPage: parseInt(params.perPage),
    //     },
    //   };
    // }
    // this.getTimeSheetToday();
    this.fetchSabbticalRequestList();

  },
  computed: {
    ...mapGetters({
      sabbaticalLeaveRequests:
        "sabbatical-leave-request/sabbaticalLeaveRequests",
      totalSabbticalRequest: "sabbatical-leave-request/totalSabbticalRequest",
      sabbaticalLeaveApproval:
        "sabbatical-leave-request/sabbaticalLeaveApproval",
      pagination: "sabbatical-leave-request/pagination",
      listItemsPerPage: "commons/listItemsPerPage",
      account: "auth/account",
      isManangerCheck: "sabbatical-leave-request/isManangerCheck",
    }),
    dataTimeSheetsNotApprover() {
      return (
        this.sabbaticalLeaveApproval.data &&
        this.sabbaticalLeaveApproval.data.filter(
          (item) => !item.account_approver_ok
        )
      );
    },
  },
  methods: {
    handleClickBtnUpdateAddtendance() {
      this.isAddAdditionTimeSheetShow = true;
    },
    handleCancelAddAdditionTimeSheet() {
      this.isAddAdditionTimeSheetShow = false;
    },
    handleOkAddAdditionTimeSheet() {
      this.isAddAdditionTimeSheetShow = false;
      this.search();
    },
    handleChangeTab(tab) {
      this.activedTab = tab;
      if (tab === "mine") {
        this.searchData.paginate.currentPage = 1;
        this.fetchSabbticalRequestList();
      }
      if (tab === "need_approve") {
        this.searchData.paginate.currentPage = 1;
        this.fetchApprovalSabbaticalRequestList();
      }
    },
    handleMineTableChange() {
      this.search();
    },
    handleApprovalTableChange() {
      this.search();
    },
    // forceRerender() {
    //   this.componentKey += 1;
    // },
    // resetForm() {
    //   this.forceRerender();
    //   this.searchData.status = 0;
    //   localStorage.removeItem("statusListTime");
    // },
    async fetchSabbticalRequestList() {
      if (
        this.searchData.sortBy !== "DESC" &&
        this.searchData.sortBy !== "ASC"
      ) {
        this.searchData.sortBy = "DESC";
      }
      await this.$store.dispatch(
        "sabbatical-leave-request/listSabbaticalLeaveRequests",
        {
          start_date: this.searchData.startDate,
          end_date: this.searchData.endDate,
          optionPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          sortColumn: this.searchData.sortColumn,
          sortBy: this.searchData.sortBy,
          status: parseInt(this.searchData.status || 0),
          // month: this.searchData.month.format('MM/YYYY'),
          approvePerson: this.searchData.approvePerson.toLowerCase(),
        }
      );
      this.searchData.paginate = this.pagination;
    },
    
    async fetchApprovalSabbaticalRequestList() {
      await this.$store.dispatch(
        "sabbatical-leave-request/listSabbaticalLeaveApproval",
        {
          employeeInfo: this.searchData.employeeInfo.toLowerCase(),
          optionPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          divisionCode: this.searchData.divisionCode,
          positionId: parseInt(this.searchData.positionId),
          reason: this.searchData.reason,
          sortColumn: this.searchData.sortColumn,
          sortBy: this.searchData.sortBy,
          status: this.searchData.statusTab2
            ? parseInt(this.searchData.statusTab2)
            : null,
          approveStatus: parseInt(this.searchData.approveStatus),
          start_date: this.searchData.startDate,
          end_date: this.searchData.endDate,
        }
      );
      this.searchData.paginate = this.pagination;
      this.isCanCheck = [];
      if (this.sabbaticalLeaveApproval.data.length > 0) {
        const statusManager = [4,5];
        this.sabbaticalLeaveApproval.data.forEach(element => {
          const status = element.status;
          const id = element.id;
          const editable = element.editable;
          element.sabbatical_leave_approves.forEach((element) => {
            if (status == 1 && (element.status == 1 || statusManager.includes(element.status))  && this.account.id == element.employee_id && editable) {
              this.isCanCheck.push(id);
            }
          });
        });
      }
    },
    updateFilter(filter) {
      this.searchData = {
        ...this.searchData,
        ...filter,
      };
      this.searchData.startDate=this.searchData.startDate ? moment(this.searchData.startDate).format("DD/MM/YYYY") :moment().startOf('month').format('DD/MM/YYYY') ;
      this.searchData.endDate=this.searchData.endDate ? moment(this.searchData.endDate).format("DD/MM/YYYY"):moment().endOf('month').format('DD/MM/YYYY');
      this.searchData.paginate.currentPage = 1;
      // this.passParamUrl();
      this.search();
    },
    // checkDataParam(data) {
    //   return data === 0 || data === "" ? undefined : data;
    // },
    // passParamUrl() {
    //   this.$router
    //     .push({
    //       name: "Additional Timesheet",
    //       query: {
    //         employeeInfo: this.checkDataParam(this.searchData.employee_info),
    //         month: this.checkDataParam(
    //           moment(this.searchData.month).format("MM/YYYY")
    //         ),
    //         status: this.searchData.status
    //           ? this.checkDataParam(parseInt(this.searchData.status))
    //           : "",
    //         currentPage: this.checkDataParam(
    //           this.searchData.paginate.currentPage
    //         ),
    //         perPage: this.checkDataParam(this.searchData.itemsPerPage),
    //         sortColumn: this.checkDataParam(this.searchData.sortColumn),
    //         sortBy: this.checkDataParam(this.searchData.sortBy),
    //       },
    //     })
    //     .catch(() => {});
    // },
    async search() {
      // if (this.$route.fullPath !== "/additional-timesheet") {
      //   this.clearParamUrl();
      // }
      this.$root.$loading.start();
      try {
        if (this.activedTab === "mine") {
          this.fetchSabbticalRequestList();
        }
        if (this.activedTab === "need_approve") {
          this.fetchApprovalSabbaticalRequestList();
        }
        this.$root.$loading.finish();
      } catch {
        this.$root.$loading.finish();
      }
    },
    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: "",
      };
    },
    async deleteItem(overTimeRequestId) {
      this.$confirmModal(
        this.$t("popup.additional-timesheet.label_popup_content"),
        this.$t("popup.additional-timesheet.label_popup_title"),
        this.$t("popup.additional-timesheet.label_confirm_button"),
        this.$t("popup.additional-timesheet.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.deleteAdditionalTimeSheet(overTimeRequestId)
            .then(() => {
              this.fetchSabbticalRequestList();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    changePage() {
      // this.passParamUrl();
      this.fetchSabbticalRequestList();
    },
    changePageApprover() {
      this.$refs.approved_ref.unCheckSelectedAll(false);
      // this.passParamUrl();
      this.fetchApprovalSabbaticalRequestList(
      );
    },
    // checkDataParam(data) {
    //   return data === 0 || data === "" ? undefined : data;
    // },
    // passParamUrl() {
    //   return;
    // this.$router.push({
    //   name: "Additional Timesheet",
    //   query: {
    //     month: this.checkDataParam(this.searchData.month.format("MM/YYYY")),
    //     status: this.checkDataParam(parseInt(this.searchData.status)),
    //     currentPage: this.checkDataParam(
    //       this.searchData.paginate.currentPage
    //     ),
    //     perPage: this.checkDataParam(this.searchData.itemsPerPage),
    //     sortColumn: this.checkDataParam(this.searchData.sortColumn),
    //     sortBy: this.checkDataParam(this.searchData.sortBy),
    //   },
    // });
    // },
    // clearParamUrl() {
    //   return;
    //   // this.$router.push({ name: "Additional Timesheet" });
    // },
    // convertParamsDate(date) {
    //   if (!date) return "";
    //   let d = moment(date, "DD/MM/YYYY");
    //   return d.format("DD-MM-YYYY");
    // },
    // reverseParamsDate(date) {
    //   if (!date) return "";
    //   let d = moment(date, "DD-MM-YYYY");
    //   return d.format("DD/MM/YYYY");
    // },
    // checkParamIsDate(date) {
    //   return moment(date, "DD-MM-YYYY", true).isValid();
    // },
    // resetParams() {
    //   if (this.$route.fullPath !== "/additional-timesheet") {
    //     this.clearParamUrl();
    //   }
    //   this.searchData = {
    //     month: moment(),
    //     status: 0,
    //     // status_sabbatical_request: 0,
    //     itemsPerPage: 10,
    //     employee_info: "",
    //     paginate: {
    //       from: 0,
    //       to: 0,
    //       totalPage: 0,
    //       path: "",
    //       currentPage: 1,
    //       totalRecord: 0,
    //       perPage: 0,
    //     },
    //   };
    // },

    // sortByColumn(column) {
    //   if (this.searchData.sortColumn != column) {
    //     this.searchData.sortBy = "DESC";
    //   }
    //   this.searchData.sortColumn = column;
    //   this.searchData.sortBy =
    //     this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
    //   this.passParamUrl();
    //   this.fetchSabbticalRequestList();
    // },

    // classStatusSort(column) {
    //   return this.searchData.sortColumn === column &&
    //     this.searchData.sortBy === "ASC"
    //     ? "sort-rotate"
    //     : "";
    // },
    passDataApproved(data) {
      this.listIdsSabbaticalRequestApproved = data;
    },
    showModalNote(status) {
      this.forms.comment = "";
      this.forms.status = status;
      this.$refs["modal-note"].show();
    },
    hideModalNote() {
      this.$refs["modal-note"].hide();
    },
    async approveAllSabbaticalRequest() {
      if (this.listIdsSabbaticalRequestApproved.length > 0) {
        this.$root.$loading.start();
        this.$refs.approved_ref.unCheckSelectedAll(false);
        await this.$store
          .dispatch("sabbatical-leave-request/approvalListSabbatical", {
            data: this.forms,
            sabbaticalRequestsApprovals: this.listIdsSabbaticalRequestApproved,
          })
          .then(() => {
            let message = this.$t("overtime.message_approval_success");
            this.$toast(message, null, 2000, "b-toaster-top-center", "success");
            this.allSelected = false;
            this.isCanCheck = [];
            this.listIdsSabbaticalRequestApproved = [];
            this.handleApprovalTableChange();
            this.$store.dispatch("commons/getCountRequest");

            this.allSelected = false;
            this.$root.$loading.finish();
          })
          .catch(() => {
            this.hideModalNote();
            this.listIdsSabbaticalRequestApproved = [];
            this.allSelected = false;
            this.$root.$loading.finish();
          });
      }
      this.hideModalNote();
    },
    openAddSabbaticalRequestModal() {
      // let routeData = this.$router.resolve({
      //     name: "Employee Sabbatical Leave Create",
      //   });
      //   window.open(routeData.href, "_blank");
      if(this.isManangerCheck == false)
      {
        this.errorModal = true
      }
      else
      {
        this.$router.push({ path: `/sabbatical-leave-request/create`})
      }
      // this.$refs.createSabbatical.show();
    },

    hideErrorConfirm()
    {
      this.errorModal = false;
    }
  },
  watch: {
    // $route(to) {
    //   if (to.fullPath === "/additional-timesheet") {
    //     this.resetParams();
    //     this.fetchSabbticalRequestList();
    //   }
    // },
    totalSabbticalRequest() {
      this.countRequest.mine =
      this.totalSabbticalRequest?.requestPending || 0;
      this.countRequest.need_approve =
      this.totalSabbticalRequest?.requestApproval || 0;
    },
  },
};
</script>
<style>
.anticon {
  vertical-align: middle !important;
}
</style>

<style lang="scss" scoped>
.icon_add {
  font-weight: bold;
  margin-right: 3px;
  color: #3d4cdc;
}
.card-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.btn-update-attendance {
  background: #ececec;
  gap: 10px;
  border-radius: 10px;
  padding: 10px 20px;
  color: #3d4cdc;
  font-weight: bold;
  &:focus {
    box-shadow: none !important;
  }
}

// /deep/ .anticon {
//   margin-right: 10px;
// }

router-link {
  text-decoration: none;
}
.btn-search {
  margin-top: 25px;
}
.btn-search-employee {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}
.list-tabs {
  list-style-type: none;
  text-align: center;
  align-items: center;
  padding-left: 0px;
  margin-bottom: 0px;
  display: flex;
  color: #1f2d3d;
  li {
    color: #000000;
    padding: 14px 26px;
    cursor: pointer;

    &.active {
      background-color: rgba(17, 143, 166, 0.1);
      font-weight: 500;
      border-bottom: 2px solid #118fa6;
      margin-bottom: -2px;
      color: #118fa6;
    }
  }
}
// .btn-search {
//   margin: 0 auto;
// }
.card-body {
  padding: 1.25rem 1;
}
.filter_label {
  font-weight: 400;
  color: #000000;
}
.work-time_start {
  // display: flex;
  align-items: center;
  justify-content: center;
  // width: 60%;
  background: #eff2f7;
  border-radius: 73px;
  padding: 2px 10px;

  font-weight: 700;
  color: #0c7c8e;
  // .span{
  //   width: 60%;
  // }
  span {
    font-weight: 700;
    color: #0c7c8e;
  }
}
.span_time {
  font-weight: bold;
  color: #1190a6;
  margin-left: 5px;
}
.btn-fix__timeSheet {
  border: 1px solid #118fa6;
  border-radius: 4px;
  padding: 4px 8px;
  background: #ffffff;

  img {
    height: 14px;
    width: 14px;
    margin-right: 4px;
  }

  span {
    color: #118fa6;
  }
}
.btn-fix__timeSheet_delete {
  border: 1px solid #df315b;
  border-radius: 4px;
  padding: 4px 8px;
  background: #ffffff;
  margin-left: 5px;

  img {
    height: 15px;
    width: 15px;
    margin-right: 4px;
  }

  span {
    color: #df315b;
  }
}
.filter-header {
  // padding: 10px;
  border: 1px solid #dde2e5;
  background: #ffffff;
  // border-bottom: 1px solid #dde2e5;
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
  padding: 10px;
  border-radius: 2px;
}
.time-sheet__button {
  .router_button {
    background: #118fa6;
    color: #ffffff;
    border-radius: 5px;
    border: 1px solid #118fa6;
    padding: 5px 10px;
    img {
      margin-right: 5px;
    }
  }
  .btn-accept-employee-overtime {
    background: #3d4cdc;
    height: 40px;
    width: 138px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
  }
  .btn-reset {
    background: #ebebeb;
    height: 40px;
    width: 138px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 14px;
  }
}
.table-list {
  width: 100%;
  // padding-right: 15px;
  // padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  .cl-pointer {
    cursor: pointer;
    .icon-sort {
      margin-left: 5px;
      .c-icon {
        width: 12px;
      }
      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}

.color-status-1 {
  span.badge.badge-secondary {
    background-color: white;
    font-weight: 700;
    color: #f58722;
    font-size: 14px;
  }
}

.color-status-4 {
  span.badge.badge-secondary {
    background-color: white;
    font-weight: 700;
    color: #626262;
    font-size: 14px;
  }
}

.color-status-3 {
  span.badge.badge-secondary {
    background-color: white;
    color: #f03d3e;
    font-weight: 700;
    font-size: 14px;
  }
}

.color-status-2 {
  span.badge.badge-secondary {
    background-color: white;
    color: #17a896;
    font-weight: 700;
    font-size: 14px;
  }
}

.max-w-200 {
  max-width: 200px;
}

.min-w-240 {
  min-width: 240px;
}
.tabs-control-overtime-request {
  padding: 0 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none !important;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 0 !important;

  .time-sheet__header {
    font-weight: 700;
    font-size: 18px;
    color: #3d4cdc;
  }
}
.form-group_tab {
  border-bottom: 1px solid #dde2e5;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  background: #ffffff;
  border-radius: 4px;
  justify-content: space-between;
  ul {
    list-style-type: none;
    text-align: center;
    align-items: center;
    padding-left: 0px;
    margin-bottom: 0px;
    display: flex;
    color: #1f2d3d;

    li {
      padding: 15px;
      margin-right: 15px;
      cursor: pointer;
    }
    .active {
      background-color: rgba(17, 143, 166, 0.1);
      color: #118fa6;
      font-weight: 500;
      border-bottom: 2px solid #118fa6;
    }
  }
  .time-sheet {
    margin-top: -32px;
    padding: 0;
  }
}
.card-table-emloyee {
  background: #ffffff;
  padding: 30px;
}
.card {
  margin-top: 30px;
}
</style>

<style lang="scss" scoped>
.search-box {
  padding-top: 13px;
  text-align: center;
}

.filter {
  padding: 0rem 1rem 1rem;
}

tr.day-off {
  background-color: #f0f8ff;
}

th,
td {
  vertical-align: middle !important;
}

.required {
  color: #dc1313;
  font-size: 13px;
}

.option-table {
  display: flex;
  justify-content: space-between;
}

.btn-search-timesheet {
  display: flex;
  height: 40px;
  border-radius: 5px;
  background-color: #118fa6;
  padding: 0 16px;
  align-items: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 16px;

  img {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .work-time_start {
    width: 100%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .table {
    width: 1300px;
  }
}
@media screen and (max-width: 740px) {
  .filter {
    margin: -1rem 0 0 0 !important;
    padding: 1rem !important;
  }
  .search-box {
    padding: 0;
    text-align: center;
    margin-bottom: 15px;
  }
  .table-list {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .table {
    width: 1300px;
  }
  .row-mobile {
    margin-top: 10px;
  }
}
</style>
